import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-4" }
const _hoisted_2 = { class: "w-28 h-28 p-2 rounded border flex items-center justify-center flex-shrink-0" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "flex flex-1 flex-col min-w-0 items-start" }
const _hoisted_5 = {
  class: "text-lg font-semibold w-full",
  "data-dusk": "product-title"
}

import { computed } from 'vue';
import type { ProductImage, HighlightBgColor } from '@/models/webshop.model';
import NumberBadge from '@/lib/components/Badge/NumberBadge.vue';
import { useImageRetry } from '@/composables/use-image-retry';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductPrimaryInfo',
  props: {
    title: {},
    image: {},
    highlightText: {},
    highlightColor: {}
  },
  setup(__props: any) {

const props = __props;

const normalizedHighlightText = computed(() => (props.highlightText ?? '').trim());
const normalizedHighlightColor = computed<HighlightBgColor | null>(() => props.highlightColor ?? null);
const shouldShowHighlight = computed(() => normalizedHighlightText.value.length > 0 && normalizedHighlightColor.value !== null);
const rawImageUrl = computed(() => props.image?.url ?? '');
const { imgSrc, fallbackSrc, onImgError, onImgLoad } = useImageRetry(rawImageUrl, {
  maxRetries: 4,
  baseDelayMs: 250
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _unref(imgSrc) || _unref(fallbackSrc),
        alt: props.title,
        class: "max-w-full max-h-full object-contain",
        onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onImgLoad) && _unref(onImgLoad)(...args))),
        onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(onImgError) && _unref(onImgError)(...args)))
      }, null, 40, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h2", _hoisted_5, _toDisplayString(props.title), 1),
      (shouldShowHighlight.value)
        ? (_openBlock(), _createBlock(NumberBadge, {
            key: 0,
            class: "self-start",
            "badge-number": 0,
            "show-number": false,
            text: normalizedHighlightText.value,
            color: normalizedHighlightColor.value,
            "data-dusk": "product-highlight-label"
          }, null, 8, ["text", "color"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})